import React, { FC } from "react";
import { Typography, Button, Stack, SxProps, Theme } from "@mui/material";
import palette from "../../../theme/palette";
import { FONT_SECONDARY } from "../../../theme/typography";
import RightArrow from "../../../assets/svg-fc/RightArrow";

interface iTitleAndLinkProps {
  title: string;
  btnText?: string;
  sx?: SxProps<Theme>;
  actionBtn?: () => void;
}

const TitleAndLink: FC<iTitleAndLinkProps> = ({
  title,
  btnText,
  sx,
  actionBtn,
}) => {
  return (
  <Stack sx={{ flexDirection: "row", alignItems: "center", mb: 1.25, ...sx, "& h2": { fontSize: 20 } }}>
      <Typography
        variant="h2" sx={{ color: palette.secondary.main, fontFamily: FONT_SECONDARY, fontWeight: 600 }}>
        {title}
      </Typography>
      {btnText && (
        <Button
          variant="text"
          onClick={actionBtn}
          sx={{
            bgcolor: "transparent",
            p: 0,
            fontSize: 14,
            marginInlineStart: "auto",
            justifyContent: "flex-end",
            fontWeight: 500,
            textDecoration: "underline",
            gap: 1,
            "&:hover": { bgcolor: "transparent" },
            "& svg": {
              width: 7,
            },
          }}
        >
          {btnText}
          <RightArrow />
        </Button>
      )}
    </Stack>
  );
};

export default TitleAndLink;
